import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdmirRatingsComponent } from './admir-ratings/admir-ratings.component';
import { PayPalPayComponent } from './pay-pal-pay/pay-pal-pay.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [AdmirRatingsComponent, PayPalPayComponent],
    exports: [AdmirRatingsComponent, PayPalPayComponent],
    schemas: []
})
export class CustomControlsModule { }
